import LogoGrande from '../LogoGrande/LogoGrande';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { ROUTES } from '../../const/routes';

const BannerFichas = () => {
  return (
    <div className="relative h-[120px] sm:h-[140px] md:h-[160px] lg:h-[180px] w-full mx-auto bg-gradient-to-b from-slate-950 to-teal-800 overflow-hidden">
      <div
        className="h-full w-full"
        style={{
          backgroundImage: `url(${ROUTES.rutaBanners}BannerFichasResized.png)`,
          backgroundRepeat: 'repeat-x',
          backgroundSize: 'auto 100%',
          backgroundPosition: 'center',
        }}
      />
      {/* Contenedor centrado para el LogoGrande */}
      <div className="absolute inset-0 flex justify-center items-center py-3">
        <LogoGrande />
      </div>
      {/* Selector de idioma — esquina superior derecha */}
      <div className="absolute top-2 right-3 md:top-3 md:right-5">
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default BannerFichas;
